@for (ac of kaizenAccountList; track ac; let i = $index) {
  <ng-container class="accountblock">
    <div class="card m-6">
      <h5 class="card-header">Account #{{i+1}}</h5>
      <div class="card-body">
        <div class="form-group row">
          <div class="form-group row">
            <label for="costDirectionId" class="col-sm-6 col-form-label">Cost Direction : </label>
            <div class="col-sm-4">
              <label class="  col-form-label"><b>{{ac.costDirectionsText}} </b></label>
            </div>
          </div>
          <div class="form-group row">
            <label for="costTypeId" class="col-sm-6 col-form-label">Cost Type : </label>
            <div class="col-sm-4">
              <label class="  col-form-label"><b>{{ac.costTypesText}}</b></label>
            </div>
          </div>
          <div class="form-group row">
            <label for="gLAccountImpactAreaID" class="col-sm-6 col-form-label">Account : </label>
            <div class="col-sm-4">
              <label class="  col-form-label"><b>{{ac.accountsText}}</b></label>
            </div>
          </div>
          <div class="form-group row">
            <label for="detailAccountID" class="col-sm-6 col-form-label">Account Detail : </label>
            <div class="col-sm-4">
              <label class="  col-form-label"><b>{{ac.detailedAccountsText}}</b></label>
            </div>
          </div>
          <div class="form-group row">
            <label for="savingsMeasure" class="col-sm-6 col-form-label">Savings Measure : </label>
            <div class="col-sm-4">
              <label class="  col-form-label"><b>{{ac.savingsMeasureText}}</b></label>
            </div>
          </div>
        </div>
      </div>
      <br>
        @if (ac.savingsMeasureText=='Process Reduction') {
          <div class="col-md-12">
            <div class="">
              <h5 class="card-header">Process Reduction</h5>
            </div>
            <div style="text-align: right;">Operation Rate : <b>{{kaizenAccountArray.data[i].operationRate}}</b></div>
            <div style="text-align: right;">Takt Time : <b>{{kaizenAccountArray.data[i].taktTime}}</b></div>
            <div style="text-align: right;">Currency : <b>{{kaizenAccountArray.data[i].currencyCode}}</b></div>
            <div style="overflow-y: scroll;">
              <table style="width: 100%;" class="table table-bordered ">
                <thead>
                  <tr>
                    <th></th>
                    @for ( c of KaizenMonthlySavingAccountsAry[i]; track  c) {
                      <th style="text-align: center;">{{c.monthHead}}</th>
                    }
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th style="text-align: right;">Process Reduction</th>
                    @for (c of KaizenMonthlySavingAccountsAry[i]; track c) {
                      <td style="text-align: center;">{{c.processReduction}}</td>
                    }
                  </tr>
                  <tr>
                    <th style="text-align: right;">Working Days</th>
                    @for (c of KaizenMonthlySavingAccountsAry[i]; track c) {
                      <td style="text-align: center;">{{c.workingDays}}</td>
                    }
                  </tr>
                  <tr>
                    <th style="text-align: right;">Number of Shifts</th>
                    @for (c of KaizenMonthlySavingAccountsAry[i]; track c) {
                      <td style="text-align: center;">{{c.numberOfShifts}}</td>
                    }
                  </tr>
                  @if (viewRate) {
                    <tr>
                      <th style="text-align: right;">Standard Rate</th>
                      @for (c of KaizenMonthlySavingAccountsAry[i]; track c) {
                        <td style="text-align: center;">{{c.standardRate}}</td>
                      }
                    </tr>
                  }
                  <tr>
                    <th style="text-align: right;">Monthly Savings</th>
                    @for (c of KaizenMonthlySavingAccountsAry[i]; track c) {
                      <td style="text-align: center;">
                      ${{c.monthlySavings | number}}</td>
                    }
                  </tr>
                  <tr>
                    <th style="text-align: right;">Cumulative Savings</th>
                    @for (c of KaizenMonthlySavingAccountsAry[i]; track c; let j = $index) {
                      <td style="text-align: center;">
                      ${{prCumulativeSavings[i][j] | number}}</td>
                    }
                  </tr>
                  <tr>
                    <th style="text-align: right;">Volume</th>
                    @for (c of KaizenMonthlySavingAccountsAry[i]; track c) {
                      <td style="text-align: center;">{{c.capacity}}</td>
                    }
                  </tr>
                  <tr>
                    <th style="text-align: right;">CPU Savings</th>
                    @for (c of KaizenMonthlySavingAccountsAry[i]; track c) {
                      <td style="text-align: center;">
                      ${{c.costPerUnitSavings |number}}</td>
                    }
                  </tr>
                </tbody>
              </table>
            </div>
            <br>
              <div class="col-md-12">
                <label class="col-sm-4">
                  <h3>Total Savings : ${{kaizenAccountArray.data[i].totalSavings | number}}</h3>
                </label>
                <label class="col-sm-4">
                  <h3>Total Volume : {{(kaizenAccountArray.data[i].totalVolume  | number)}}</h3>
                </label>
                <label class="col-sm-4">
                  <h3>Average CPU Savings : {{kaizenAccountArray.data[i].averageCPUSavings | currency}}</h3>
                </label>
              </div>
              <div class="col-md-12">
                <label class="col-sm-4">
                  <h3>Next Year Total Savings : ${{kaizenAccountArray.data[i].nextFYTotalSavings | number}}</h3>
                </label>
              </div>
            </div>
          }
          @if (ac.savingsMeasureText=='Total Working Time Reduction') {
            <div>
              <div>
                <h5 class="card-header">Total Working Time Reduction (TWT) </h5>
              </div>
              <div style="text-align: right;">Operation Rate : <b>{{kaizenAccountArray.data[i].operationRate}}</b></div>
              <div style="text-align: right;">Takt Time : <b>{{kaizenAccountArray.data[i].taktTime}}</b></div>
              <div style="text-align: right;">Currency : <b>{{kaizenAccountArray.data[i].currencyCode}}</b></div>
              <br>
                <div id='TotalWorkingTimeReduction' class="well " style="overflow-y: scroll;">
                  <table style="width: 100%;" class="table table-bordered ">
                    <thead>
                      <tr>
                        <th></th>
                        @for ( c of KaizenMonthlySavingAccountsAry[i]; track  c) {
                          <th style="text-align: center;">{{c.monthHead}}</th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th style="text-align: right;">Hourly Reduction</th>
                        @for (c of KaizenMonthlySavingAccountsAry[i]; track c) {
                          <td style="text-align: center;">{{c.twtReduction}}</td>
                        }
                      </tr>
                      <tr>
                        <th style="text-align: right;">Number of Shifts</th>
                        @for (c of KaizenMonthlySavingAccountsAry[i]; track c) {
                          <td style="text-align: center;">{{c.numberOfShifts}}</td>
                        }
                      </tr>
                      <tr>
                        <th style="text-align: right;">Working Days</th>
                        @for (c of KaizenMonthlySavingAccountsAry[i]; track c) {
                          <td style="text-align: center;">{{c.workingDays}}</td>
                        }
                      </tr>
                      <tr>
                        <th style="text-align: right;">TWT Savings</th>
                        @for (c of KaizenMonthlySavingAccountsAry[i]; track c; let j = $index) {
                          <td style="text-align: center;">{{c.twtReduction*c.numberOfShifts*c.workingDays}}</td>
                        }
                      </tr>
                      <!-- <tr *ngIf="viewRate">
                      <th style="text-align: right;">Standard Rate</th>
                      <td *ngFor='let c of KaizenMonthlySavingAccountsAry[i]' style="text-align: center;">{{c.standardRate}}</td>
                    </tr> -->
                    <tr>
                      <th style="text-align: right;">Monthly Savings</th>
                      @for (c of KaizenMonthlySavingAccountsAry[i]; track c; let i = $index) {
                        <td style="text-align: center;">
                        ${{c.monthlySavings | number}}</td>
                      }
                    </tr>
                    <tr>
                      <th style="text-align: right;">Volume</th>
                      @for (c of KaizenMonthlySavingAccountsAry[i]; track c) {
                        <td style="text-align: center;">{{c.capacity}}</td>
                      }
                    </tr>
                    <tr>
                      <th style="text-align: right;">CPU Savings</th>
                      @for (c of KaizenMonthlySavingAccountsAry[i] ; track c; let i = $index) {
                        <td style="text-align: center;">${{
                        c.costPerUnitSavings |number}}</td>
                      }
                    </tr>
                  </tbody>
                </table>
              </div>
              <br>
                <div class="col-md-12">
                  <label class="col-sm-4">
                    <h3>Total Monthly Savings : ${{kaizenAccountArray.data[i].totalSavings | number}}</h3>
                  </label>
                  <label class="col-sm-4">
                    <h3>Total Volume : {{(kaizenAccountArray.data[i].totalVolume | number)}}</h3>
                  </label>
                  <label class="col-sm-4">
                    <h3>Average CPU Savings : {{kaizenAccountArray.data[i].averageCPUSavings  | currency}}</h3>
                  </label>
                </div>
              </div>
            }
            @if (ac.savingsMeasureText=='Total Cost') {
              <div class="card m-3">
                <h5 class="card-header">Total Cost</h5>
                <div style="text-align: right;">Currency : <b>{{kaizenAccountArray.data[i].currencyCode}}</b></div>
                <div class="card-body">
                  <div id='showTotalCostTable' class="well" style="overflow-y: scroll;">
                    <table style="width: 100%;" class="table table-bordered">
                      <thead>
                        <tr>
                          @for ( c of KaizenMonthlySavingAccountsAry[i]; track  c) {
                            <th style="text-align: center;">{{c.monthHead}}</th>
                          }
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          @for ( d of KaizenMonthlySavingAccountsAry[i]; track  d) {
                            <td style="text-align: center;">${{d.monthlySavings}}</td>
                          }
                          <th>${{tableTotal[i] | number}}</th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            }
            @if (ac.savingsMeasureText=='Cost Per Unit') {
              <div class="card m-1">
                <h5 class="card-header">Cost Per Unit (CPU) : $ {{kaizenAccountArray.data[i].costPerUnit}} Savings/Vehicle</h5>
                <div style="text-align: right;">Currency : <b>{{kaizenAccountArray.data[i].currencyCode}}</b></div>
                <div class="card-body">
                  <div id='option2' class="well" style="overflow-y: scroll;">
                    <br>
                      <table style="width: 100%;" class="table table-bordered">
                        <thead>
                          <tr>
                            <th></th>
                            @for ( c of KaizenMonthlySavingAccountsAry[i]; track  c) {
                              <th style="text-align: center;">{{c.monthHead}}</th>
                            }
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th style="text-align: right;">Volume</th>
                            @for (c of KaizenMonthlySavingAccountsAry[i]; track c) {
                              <td style="text-align: center;">{{c.capacity}}</td>
                            }
                          </tr>
                          <tr>
                            <th style="text-align: right;">Savings</th>
                            @for (c of KaizenMonthlySavingAccountsAry[i]; track c) {
                              <td style="text-align: center;">
                                ${{c.monthlySavings | number}}
                              </td>
                            }
                          </tr>
                        </tbody>
                      </table>
                      <br>
                        <div class="col-md-12">
                          <table>
                            <tr>
                              <td><h3>FY{{fyText}} Savings :</h3></td>
                              <td style="text-align:right"><h3>${{kaizenAccountArray.data[i].totalSavings | number}}</h3></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td><h3>FY{{fyNextText}} Savings : </h3></td>
                              <td style="text-align:right"><h3>${{kaizenAccountArray.data[i].nextFYTotalSavings | number}}</h3></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td><h3>12 Month Savings : </h3></td>
                              <td style="text-align:right"><h3>${{kaizenAccountArray.data[i].totalSavings+kaizenAccountArray.data[i].nextFYTotalSavings | number}}</h3></td>
                              <td></td>
                            </tr>
                          </table>
                          <label class="col-sm-4">
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
              <div style="padding-left: 10px;">
                <br>
                  <strong>Notes:</strong>
                  <br>
                    Kaizens with a "Cost Increase" cost direction will apply a negative net monthly savings calculation.
                    <br>
                      Kaizens with a "Cost Decrease" cost direction will apply a positive net monthly savings calculation.
                      <br>
                        Kaizens with a "Cost Neutral" cost direction will have no impact on the net monthly savings calculation.
                        <br>
                          <br>
                          </div>
                          <br> <br>
                        </ng-container>
                      }

                      <br>
                        @if (tblNetSavingsShow && !multipleCurrencies) {
                          <div class="card m-3">
                            <h3 class="card-header">Net Savings</h3>
                            <div class="container">
                              <div class="row">
                                <div style="overflow-y: scroll;">
                                  <table style="width: 100%;" class="table table-bordered">
                                    <thead>
                                      <tr>
                                        <th></th>
                                        @for ( c of dateHeader; track  c) {
                                          <th style="text-align: center;">{{c}}</th>
                                        }
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <th style="text-align: right;">Process Reduction</th>
                                        @for (c of KaizenMonthlySavingAccountsAry[0]; track c; let x = $index) {
                                          <td style="text-align: center;">
                                          {{nsProcessReduction[x]}}</td>
                                        }
                                      </tr>
                                      <tr>
                                        <th style="text-align: right;">TWT Reduction</th>
                                        @for (c of KaizenMonthlySavingAccountsAry[0]; track c; let x = $index) {
                                          <td style="text-align: center;">{{nsTwtReduction[x]}}
                                          </td>
                                        }
                                      </tr>
                                      <tr>
                                        <th style="text-align: right;">Monthly Savings</th>
                                        @for (c of KaizenMonthlySavingAccountsAry[0]; track c; let x = $index) {
                                          <td style="text-align: center;">${{nsMonthlySavings[x] | number}}
                                          </td>
                                        }
                                      </tr>
                                      <tr>
                                        <th style="text-align: right;">CPU Savings</th>
                                        @for (c of KaizenMonthlySavingAccountsAry[0]; track c; let x = $index) {
                                          <td style="text-align: center;">${{nsCpuSavings[x] | number:'.2-2'}}
                                          </td>
                                        }
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                        <div>
                          @if (multipleCurrencies) {
                            <h3 style="text-align: center;">Net Savings cannot be calculated because this Kaizen has accounts with different currencies.</h3>
                          }
                          <br>
                            <br>
                            </div>